<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="choose-practice-sidebar-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="choose-practice-sidebar-form" @submit.prevent="onSubmit">
        <div class="choose-practice-sidebar-form-body">
          <v-toolbar
            flat
            height="76"
          >
            <v-toolbar-title class="choose-practice-sidebar-toolbar-title">Company</v-toolbar-title>
            <v-spacer></v-spacer>
            <dialog-select 
              name="status"
              :items="statusFilters"
              :value="true"
              placeholder="Status"
              customClass="filter"
              itemText="label"
              itemValue="value"
              @input="filterStatus"></dialog-select>
            <v-btn
              color="accent"
              icon
              tile
              @click="closeDialog"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container class="choose-practice-sidebar-card-container">
            <dialog-input
              label="Search"
              name="search"
              :val="queryParams.name"
              @input="onSearch" />
          </v-container>
         
          <v-container class="choose-practice-sidebar-card-container pt-0">
            <v-row>
              <v-col sm="12">
                <main-user-table
                  :items="practicesComputed"
                  :items-per-page="queryParams.pageSize"
                  :server-items-length="pagination.totalCount || -1"
                  :page="queryParams.page"
                  :row-component="'choose-practice-table-row'"
                  @to-user="onInput"
                  @action:get-data="(data) => (getDataAction({ ...data, isActive: status }, false))"
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
        <v-container class="choose-practice-sidebar-card-footer d-flex justify-end">
          <v-btn
            :disabled="!formIsValidCheck"
            rounded
            color="primary"
            type="submit"
            elevation="0"
          >
            Provide
          </v-btn>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DialogInput from '@/components/forms/DialogInput.vue'
import MainUserTable from "@/components/tables/MainUserTable"
import DialogSelect from "@/components/forms/DialogSelect"
import RouterMixin from "@/mixins/router"

export default {
  name: 'ChoosePracticeDialog',
  components: {
    DialogInput,
    MainUserTable,
    DialogSelect,
  },
  mixins: [RouterMixin],
  props: {
    singleChoose: {
      type: Boolean,
      default: false
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    practicesSelected: {
      type: [Boolean, Array],
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      formIsValidCheck: false,
      practicesSelectedEditableList: [],
      queryParams: {
        isActive: true
      },
      statusFilters: [{label: 'Active', value: true}, {label: 'Active & Inactive', value: null}],
      status: 1,
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
        this.getDataAction({ ...this.defaultQueryParams, isActive: this.status }, false)
      }
    },
    practicesSelected: function (val) {
      let filteredPractices = this.practicesSelected.filter(item=>item!==null)
      this.practicesSelectedEditableList = filteredPractices
    }
  },
  computed: {
    ...mapState('practicesStates', [
      'practices',
      'pagination',
      'loading'
    ]),
    practicesComputed() {
      let arr = []
      this.practices.forEach(item=>{
        let tmp = {...item}
        tmp.selected = false
        if (this.practicesSelectedEditableList.indexOf(tmp.id)!==-1) tmp.selected = true
        arr.push(tmp)
      })
      return arr
    }
  },
  methods: {
    ...mapActions('practicesStates', [
      'getPractices'
    ]),
    getData(data) {
      if (this.dialog) this.getPractices(data);
    },
    formIsValid () {
      if (this.practicesSelectedEditableList && this.practicesSelectedEditableList.length>0)
      this.formIsValidCheck = true
      else this.formIsValidCheck = false
    },
    closeDialog () {
      this.dialog = false
      this.$emit('close-dialog')
      this.resetList()
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    onSearch (search) {
      this.resetList()
      this.getDataAction({ ...this.queryParams, name: search.value }, false)
    },
    resetList() {
      this.practicesSelectedEditableList = []
    },
    onInput ({id, value}) {
      if (!this.singleChoose) {
        let i = this.practicesSelectedEditableList.indexOf(id)
        if (value==0) {
          if (i !== -1) {
            this.practicesSelectedEditableList.splice(i, 1)
          }
        } else {
          if (i==-1)
          this.practicesSelectedEditableList.push(id)
        }
      } else {
        if (value==0)
          this.practicesSelectedEditableList = []
        else this.practicesSelectedEditableList = [id]
      }
      this.formIsValid()
    },
    onSubmit () {
      this.$emit('on-submit', this.practicesSelectedEditableList)
      this.closeDialog()
    },
    filterStatus(status){
      this.status = status.value
      this.getDataAction({ ...this.queryParams, isActive: status.value }, false)
      this.selectedPractices = []
      this.formIsValid()
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.choose-practice-sidebar {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2*$gutter}) !important;
    > .v-card {
      width: 100%;
      height: 100%;
      background-color: $bh-blue--4;
      overflow: auto;
    }
    .dialog-select.filter {
      flex-grow: 0;
      max-width: 180px;
      margin-right: 8px;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-container {
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-footer {
      padding: 1.5*$gutter;
    }
  }
  &-file-button {
    margin-right: 10px;
    .v-icon {
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
  &-file-details {
    display: inline-block;
    img {
      width: 40px;
      height: 40px;
      display: inline-block;
      vertical-align: middle;
      object-fit: cover;
      margin-right: 10px;
    }
    .v-progress-circular {
      margin-right: 10px;
    }
    .v-icon {
      margin-left: 5px;
      padding:4px;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5*$gutter;
        padding-right: 1.5*$gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25*$gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25*$gutter
    }
  }
}
</style>
